export default __webpack_public_path__ + "515f16764a7ff95a22e0aaae2f98b9fa.png";